import React from "react";
import { BellIcon, BellOutlineIcon } from "../../../utils/icones";
import NavbarActionButton from "./NavbarActionButton";

type Props = { badge: number; onClick: () => void };

export default function NotificationsButton(props: Props) {
  const Icon = props.badge === 0 ? BellOutlineIcon : BellIcon;

  return (
    <NavbarActionButton
      badge={props.badge}
      icon={<Icon fontSize={20} color="white" />}
      onClick={props.onClick}
    />
  );
}
